import React, { Component } from "react";
//import { NavLink as RouteNavLink } from "react-router-dom";
import { NavItem, NavLink } from "shards-react";
import { Redirect } from 'react-router-dom';

export default class SidebarNavItem extends Component {

  constructor(props){
    super(props);
    this.onRedirect = this.onRedirect.bind(this);
    this.state = {
      item : this.props.item,
      redirect : false
    }
  }

  onRedirect(){
    console.log("onRedirect");
    this.setState({redirect: true})
  }

  renderRedirect = () => {
    if (this.state.redirect) {
      return <Redirect to={this.state.item.to} />
    }
  }

  render(){
    return(
      <NavItem>
      <NavLink onClick={this.onRedirect}>
      {this.renderRedirect()}
        {this.state.item.htmlBefore && (
          <div style={{cursor: "pointer"}}
            className="d-inline-block item-icon-wrapper"
            dangerouslySetInnerHTML={{ __html: this.state.item.htmlBefore }}
          />
        )}
        {this.state.item.title && <span style={{cursor: "pointer"}}>{this.state.item.title}</span>}
        {this.state.item.htmlAfter && (
          <div
            className="d-inline-block item-icon-wrapper"
            dangerouslySetInnerHTML={{ __html: this.state.item.htmlAfter }}
          />
        )}
      </NavLink>
    </NavItem>
    )
  }
}

